<template>
  <div class="card">
    <div class="p-6">
      <div class="flex items-center justify-between mb-4">
        <div>
          <div class="text-2xl font-semibold flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-primary">
              <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
              <path d="M18 17V9"></path>
              <path d="M13 17V5"></path>
              <path d="M8 17v-3"></path>
            </svg>
            问卷评估进度
          </div>
          <div class="flex items-center gap-2 mt-2">
            <span class="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold bg-gray-100 text-psychology-primary border-gray-200">
              {{ assessmentType === 'self' ? '给自己测' : '为恋人测' }}
            </span>
          </div>
        </div>
        <div class="flex items-center gap-2">
          <span class="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold text-psychology-primary border-psychology-primary">
            {{ answered }} / {{ total }} 已完成
          </span>
        </div>
      </div>

      <!-- 进度条 -->
      <div class="space-y-4">
        <div class="relative w-full overflow-hidden rounded-full bg-gray-200 h-2">
          <div 
            class="h-full bg-psychology-primary transition-all duration-300"
            :style="{ width: progressPercentage + '%' }"
          ></div>
        </div>

        <!-- 统计卡片 -->
        <div class="grid grid-cols-3 gap-2 sm:gap-4">
          <div class="text-center p-3 bg-psychology-success/10 rounded-lg">
            <div class="text-2xl font-bold text-psychology-success">{{ answered }}</div>
            <div class="text-sm text-psychology-success">已回答</div>
          </div>
          <div class="text-center p-3 bg-psychology-warning/10 rounded-lg">
            <div class="text-2xl font-bold text-psychology-warning">{{ unanswered }}</div>
            <div class="text-sm text-psychology-warning">未回答</div>
          </div>
          <div class="text-center p-3 bg-red-50 rounded-lg">
            <div class="text-2xl font-bold text-red-600">{{ requiredUnanswered }}</div>
            <div class="text-sm text-red-600">必答未完成</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionnaireProgress',
  props: {
    total: {
      type: Number,
      required: true
    },
    answered: {
      type: Number,
      required: true
    },
    unanswered: {
      type: Number,
      required: true
    },
    requiredUnanswered: {
      type: Number,
      required: true
    },
    assessmentType: {
      type: String,
      default: 'self'
    }
  },
  computed: {
    progressPercentage() {
      return Math.round((this.answered / this.total) * 100)
    }
  }
}
</script>

